/* eslint-disable react-hooks/exhaustive-deps */
import { tokens } from "../theme";
import { useEffect, useState } from "react";
import ConvoyDialog from "./ConvoyDialog";
import { Typography, useTheme } from "@mui/material";

const contentTextStyle = (colors) => ({
  margin: 0,
  font: "400 15px/1.55 system-ui",
  color: colors.ctlInk,
  "& strong": { fontWeight: 600, color: colors.ctlInkHover },
});

const ConfirmationDialog = ({
  isOpen,
  handleDialogConfirm,
  title,
  content,
  resetDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  if (!isOpen) {
    return <></>;
  }
  return (
    <ConvoyDialog
      variant="confirmation"
      open={isOpen}
      title={title || "Confirmation"}
      handleDialogConfirm={() => {
        handleDialogConfirm();
        resetDialog();
      }}
      resetDialog={resetDialog}
    >
      <Typography component="p" sx={contentTextStyle(colors)}>
        {content || ""}
      </Typography>
    </ConvoyDialog>
  );
};

export const useConfirmationDialog = (
  title,
  useApi,
  displayNotification,
  callback
) => {
  const { postData, response, responseStatus } = useApi();

  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    title: "",
    content: "",
    handleDialogConfirm: () => {},
  });
  const resetDialog = () => {
    setConfirmationDialog({
      isOpen: false,
      title: "",
      content: "",
      handleDialogConfirm: () => {},
    });
  };

  useEffect(() => {
    displayNotification(response, responseStatus, callback);
  }, [response, responseStatus]);

  return {
    confirmationDialog: (
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        title={confirmationDialog.title}
        handleDialogConfirm={confirmationDialog.handleDialogConfirm}
        content={confirmationDialog.content}
        resetDialog={resetDialog}
      />
    ),
    showConfirmationDialog: (content, ...apiCallParams) => {
      setConfirmationDialog({
        isOpen: true,
        title,
        content,
        handleDialogConfirm: () => {
          postData(...apiCallParams);
          resetDialog();
        },
      });
    },
  };
};

export default ConfirmationDialog;
